import { BehaviorSubject, Subject } from 'rxjs';
import { IBreadcrumbNode } from '../breadcrumb/breadcrumb.component';

export class HeaderBreadcrumbManager {
  public readonly nodes$: BehaviorSubject<IBreadcrumbNode[]> = new BehaviorSubject<IBreadcrumbNode[]>([]);
  public readonly nodeClicked$: Subject<IBreadcrumbNode | undefined> = new Subject<IBreadcrumbNode | undefined>();

  public setNodes(nodes: IBreadcrumbNode[]): void {
    this.nodes$.next(nodes);
  }

  public notifyNodeClicked(node?: IBreadcrumbNode): void {
    this.nodeClicked$.next(node);
  }
}